
import React, { lazy, Suspense, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ScheduleMeeting.css';

const PopupModal = lazy(() =>
    import('react-calendly').then(module => ({ default: module.PopupModal }))
);

const ScheduleMeeting = () => {
    const [showCalendly, setShowCalendly] = useState(false);

    const handleClick = () => {
        setShowCalendly(true);
    };

    return (
        <>
            <div className="floating-button-wrapper">

                <button
                    className="animated-3d-button"
                    onClick={handleClick}
                    aria-label="Schedule a Video Meeting"
                >
                    📅 Schedule Video Meeting
                </button>


            </div>

            {showCalendly && (
                <Suspense fallback={<div className="floating-loading-spinner" />}>
                    <PopupModal
                        url="https://calendly.com/ashishky892/30min"
                        rootElement={document.getElementById('root')}
                        open={showCalendly}
                        onModalClose={() => setShowCalendly(false)}
                    />
                </Suspense>
            )}
        </>
    );
};

export default ScheduleMeeting;



